import Shopers from './filterMenuTabs/ShopersFilter'
import Projects from './filterMenuTabs/ProjectsFilter'
import 'rc-slider/assets/index.css'

import React, { useState } from 'react'
import { useObserver } from 'mobx-react'
import { useText } from '../../texts'

function FilterMenu({ show }) {
  const t = useText()
  const [tab, setTab] = useState('projects')

  return useObserver(() => (
    <div className={`filter-card filter-menu ${show ? 'active' : ''}`}>
      <div className="filter-menu-header">
        <div
          onClick={() => setTab('projects')}
          className={`filter-menu-header__item ${
            tab === 'projects' ? 'active' : ''
          }`}
        >
          {t('projects')}
        </div>
        <div
          onClick={() => setTab('shoppers')}
          className={`filter-menu-header__item ${
            tab === 'shoppers' ? 'active' : ''
          }`}
        >
          {t('shoppers')}
        </div>
      </div>

      {tab === 'projects' ? (
        <Projects />
      ) : (
        <Shopers changeTab={() => setTab('projects')} />
      )}
    </div>
  ))
}

export default FilterMenu
